import React, { useEffect, useState, useRef, useCallback } from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';
import { observer } from 'mobx-react-lite';
import Model from '../../../../model';
import Page from '../../../pages/Page';
import courseLogo from './images/course-logo.png';
import { AudioItem } from 'components/Audio/Item';
import { DownloadItem } from 'components/DownloadItem';
import { OtvetAudioPlayer } from 'components/Audio';
import { Quote } from 'components/Quote';
import './index.sass';

const { cnBlock, el } = bem( 'supervision-course-materials' )

const itemName = '«Психолог моего психолога» - проект супервизий Вероники Сидоровой'

const title = `«Психолог моего\nпсихолога»`;
const subtitle = 'Рабочие материалы';

const SupervisionsMaterials =  () => {

    const { user } = Model;
    const [ activeChapter, setActiveChapter ] = useState( 0 );
    const [ isPlaying, setIsPlaying ] = useState( false );
    const [ showPlayer, setShowPlayer ] = useState( false );
    const [ loading, setLoading ] = useState(false);
    const [ item, setItem ] = useState( null );

    const player = useRef( null );

    useEffect(() => {
        setLoading(true);
        user.getDigital(itemName)
            .then((digital) => {
                setLoading(false);
                if (digital !== undefined) {
                    setItem(digital);
                }
            })
            .catch((error) => {
                setLoading(false)
                console.log(error);
            });
    }, []);

    if (loading) {
        return <Page className={ cnBlock( 'supervision-course-page' ) } title={title} subtitle={subtitle} loading={loading} />
    }

    if ( !item ) {
        return <Page className={ cnBlock( 'supervision-course-page' ) } title={title} subtitle={subtitle}>
            <div className={ el( 'content' ) }>
                <div className={ el('info') }>
                    <Text>{`Курс не был приобретен для пользователя ${user.username}`}</Text>
                </div>
            </div>
        </Page>
    }

    const files = item?.digital?.files.filter(file => !!file.isActive);

    if (files.length === 0) {
        return <Page className={ cnBlock( 'supervision-course-page' ) } title={title} subtitle={subtitle}>
            <div className={ el( 'content' ) }>
                <div className={ el('info') }>
                    <Text>{`Курс не содержит материалов`}</Text>
                </div>
            </div>
        </Page>;
    }

    const nextChapterClick = () => {
        if ( activeChapter < 16 ) {
            setActiveChapter( ( oldChapter ) => oldChapter + 2 )
        }
    }

    const prevChapterClick = () => {
        if ( activeChapter > 0 ) {
            setActiveChapter( ( oldChapter ) => oldChapter - 2 )
        }
    }

    const onChapterClick = ( e ) => ( index ) => {
        if ( index === activeChapter ) {
            player?.current?.togglePlay( e )
        } else {
            setActiveChapter( index );
        }
    }

    const SupervisionsAudioItem = ({index, title}) => {
        const handleClick = useCallback((e) => {
            onChapterClick(e)(index);
        }, []);
        return <AudioItem title={title} onClick={ handleClick } isPlaying={activeChapter === index && isPlaying } />
    }

    return <Page className={ cnBlock( 'supervision-course-page' ) } title={title} subtitle={subtitle}>
        <div className={ el( 'content' ) }>
            <div className={ el('top-block')}>
                <div className={ el('description')}>
                    <Text tag='div'>
                        Перед Вами страница рабочих материалов, объединенных в проект под названием «Психолог моего психолога».
                        Здесь Вас ждут: <b>8 супервизионных сессий</b>, записанных в формате подкастов,
                        <b> дополнительные материалы</b> к каждой из записей, <b>бонусные материалы</b>.
                    </Text>
                    <Text tag='div'>У записей нет строгой очередности и тайминга, чтобы Вы могли осваивать материал в комфортном темпе.
                        Мы рекомендуем начать с первой вводной записи, в которой Вероника Сидорова и Елена Лопухина говорят
                        о сути супервизионных встреч специалистов и их старших коллег, а также ознакомиться с
                        «психодраматическим словарем» - информацией, которая объясняет суть метода,
                        в котором работают Вероника и Елена.
                    </Text>
                </div>
                <div className={el('right-sidebar')}>
                    <div className={el('image')}>
                        <img src={courseLogo} alt={'Логотип курса'} />
                    </div>
                </div>
            </div>
            <div className={ el( 'materials' ) }>
                <div className={el('supervision')}>
                    <SupervisionsAudioItem title={files[0].title} index={0}/>
                    <DownloadItem link={`/media/${files[1].file}`} title={files[1].title}/>
                </div>
                <div className={el('supervision')}>
                    <SupervisionsAudioItem title={files[2].title} index={2} />
                    <DownloadItem link={`/media/${files[3].file}`} title={files[3].title}/>
                </div>
                <Quote>«Можно по-разному думать,по-разному поддерживать»</Quote>
                <div className={el('supervision')}>
                    <SupervisionsAudioItem title={files[4].title} index={4} />
                    <DownloadItem link={`/media/${files[5].file}`} title={files[5].title}/>
                </div>
                <div className={el('supervision')}>
                    <SupervisionsAudioItem title={files[6].title} index={6} />
                    <DownloadItem link={`/media/${files[7].file}`} title={files[7].title}/>
                </div>
                <div className={el('supervision')}>
                    <SupervisionsAudioItem title={files[8].title} index={8} />
                    <DownloadItem link={`/media/${files[9].file}`} title={files[9].title}/>
                </div>
                <Quote>«Истинная причина сложных взаимоотношений со свекровью не всегда лежит в наших взаимоотношениях с партнёром»</Quote>
                <div className={el('supervision')}>
                    <SupervisionsAudioItem title={files[10].title} index={10} />
                    <DownloadItem link={`/media/${files[11].file}`} title={files[11].title}/>
                </div>
                <div className={el('supervision')}>
                    <SupervisionsAudioItem title={files[12].title} index={12} />
                    <DownloadItem link={`/media/${files[13].file}`} title={files[13].title}/>
                </div>
                <Quote>«Откровенность не означает доверие и близость»</Quote>
                <div className={el('supervision')}>
                    <SupervisionsAudioItem title={files[14].title} index={14} />
                    <DownloadItem link={`/media/${files[15].file}`} title={files[15].title}/>
                </div>
                <div className={el('supervision')}>
                    <SupervisionsAudioItem title={files[16].title} index={16} />
                    <DownloadItem link={`/media/${files[17].file}`} title={files[17].title}/>
                </div>
                <div className={el('download-block')}>
                    <DownloadItem link={`/media/${files[18].file}`} title={files[18].title} />
                    <DownloadItem link={`/media/${files[19].file}`} title={files[19].title} />
                    {files[20] && <DownloadItem link={`/media/${files[20].file}`} title={files[20]?.title} />}
                </div>
            </div>
        </div>
        <div className={ el( 'player', {'hidden': !showPlayer} ) }>
            <OtvetAudioPlayer
                src={ `/media/${ files?.[activeChapter]?.file }` }
                onPlay={ () => {
                    setIsPlaying(true);
                    setShowPlayer(true)
                }}
                onPause={ () => {
                    setIsPlaying(false);
                }}
                onClickPrevious={ prevChapterClick }
                onClickNext={ nextChapterClick }
                ref={player}
            />
        </div>
    </Page>
}

export default observer(SupervisionsMaterials);
